// extracted by mini-css-extract-plugin
module.exports = {"backButton":"-insights-template-back-button-backButton-2pNGGu-"};